
import NoteAdd from "../../../assets/filled/NoteAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function NoteAddIcon({ className, dataTestid = "NoteAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <NoteAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
